<script setup lang="ts">
import { useTokenStore } from '@/stores/token.js';

const tokenStore = useTokenStore();
</script>

<template>
  <div>
    <div v-if="tokenStore.editToken || !tokenStore.csToken">
      <label for="custom-token" class="inline-block text-sm font-medium text-gray-800 mt-2.5"> Token </label>

      <textarea
        id="custom-token"
        class="py-2 px-3 block w-full border border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
        rows="6"
        placeholder="Enter a CS token here"
        :value="tokenStore.csToken"
        @change="tokenStore.setCsToken($event.target.value)"
      ></textarea>
    </div>
  </div>
</template>
